import { createSlice } from '@reduxjs/toolkit'

import { fetchProject } from 'redux/thunks/Project'

const initialState = {
  project: {} as any,
  saving: false,
  fetching: undefined as any,
  error: null,
}

export const project = createSlice({
  name: 'project',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchProject?.pending?.toString()]: (state) => {
      state.fetching = true
    },
    [fetchProject?.fulfilled?.toString()]: (state, action) => {
      state.project = action?.payload || {}
      state.fetching = false
    },
    [fetchProject?.rejected?.toString()]: (state, action) => {
      state.error = action.payload
      state.fetching = false
    },
  },
})

export default project.reducer
